import { BrandStacked, CutsIllustration } from '@bifeai/ui';
import type { ReactNode } from 'react';

/** Pantallas de acceso: panel de marca a la izquierda, formulario a la derecha. */
export function AuthLayout({ title, subtitle, children }: { title: string; subtitle?: ReactNode; children: ReactNode }) {
  return (
    <div className="bf-auth">
      <aside className="bf-auth-panel">
        <BrandStacked />
        <div>
          <p className="bf-auth-panel-quote">Cada kilo que entra y cada peso que sale, a la vista.</p>
          <p className="bf-auth-panel-text">Ventas, stock, vencimientos, mermas y sucursales de tu carnicería en un solo lugar.</p>
        </div>
        <p className="bf-auth-panel-foot">© {new Date().getFullYear()} BifeAI</p>
        <CutsIllustration />
      </aside>
      <main className="bf-auth-form-wrap">
        <div className="bf-auth-form">
          <BrandStacked className="bf-auth-mobile-logo" />
          <div>
            <h1 className="bf-auth-title">{title}</h1>
            {subtitle && <p className="bf-auth-sub">{subtitle}</p>}
          </div>
          {children}
        </div>
      </main>
    </div>
  );
}
